export function normalizeInline(code: string) {
  return code
    .trim()
    .replace(/\r\n/g, "\n")
    .replace(/[ \t]+/g, " ")
    .replace(/[ \t]*\n[ \t]*/g, "\n");
}

export function isVolatileInline(node: HTMLScriptElement, raw: string) {
  const t = (node.type || "").toLowerCase();
  if (t === "application/ld+json") return true;
  if (/__NEXT_DATA__|self\.__next_|window\.__NUXT__/.test(raw)) return true;
  if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z/.test(raw)) return true;
  return false;
}
